<template>
  <div class="pay-order-modal">
    <detail-header
      :formDataObj="formData"
      :isSubmit="isSubmit"
      :isEdit="true"
      :pcdType="2"
      :isChangeType="isChangeType"
      :isLoaded="isLoaded"
      @payObj="getPayObj"
      :isHasDo="true"
    ></detail-header>
    <div class="pay-modal-main">
      <table-header
        @add="insertEvent"
        @remove="removeEvent"
        @copy="copyEvent"
      ></table-header>
      <!--STR 线下付款-->
      <div class="add-box clearfix">
        <vxe-table
          show-overflow
          border
          keep-source
          class="table-style"
          ref="xTable"
          max-height="270"
          :data="tableData"
          :enabled="false"
          :edit-rules="editRules"
          :auto-resize="true"
          :edit-config="{ trigger: 'click', mode: 'row', showIcon: false }"
          @cell-click="cellClickEvent"
          @scroll="$refs.xTable.clearValidate()"
          :show-footer="true"
          :footer-method="footerMethod"
          :footer-cell-class-name="footerCellClassName"
        >
          <vxe-table-column
            width="50"
            align="center"
            type="checkbox"
          ></vxe-table-column>

          <vxe-table-column
            width="60"
            align="center"
            field="index"
            title="序号"
            v-if="isImport"
          ></vxe-table-column>
          <vxe-table-column
            type="seq"
            width="60"
            align="center"
            title="序号"
            v-else
          ></vxe-table-column>

          <vxe-table-column
            field="ordersNumb"
            width="150"
            title="关联订单"
            align="center"
          >
            <!-- <template v-slot:header="{ column }">
              <span class="column-title"
                >{{ column.title }}
                <i style="color: #f00" v-show="payType === 0"> * </i></span
              >
            </template> -->
            <template v-slot="{ row }">
              <div v-if="isInitByOrder == 'seller'">
                <em>{{ row.ordersNumb }}</em>
              </div>
              <div class="link-text" v-else>
                <span @click="openOrderModal(row)" v-if="!isImport">
                  <em v-if="row.ordersList && row.ordersList.length > 1"
                    >查看关联订单</em
                  >
                  <em
                    v-else-if="row.ordersList && row.ordersList.length == 1"
                    >{{ row.ordersList[0].ordersNum }}</em
                  >
                  <em v-else>选择关联订单</em>
                </span>
                <span @click="openOrderModal(row)" v-else>
                  <em v-if="row.ordersNumb">{{ row.ordersNumb }}</em>
                  <em v-else>选择关联订单</em>
                </span>
              </div>
            </template>
          </vxe-table-column>

          <!-- 2020-09-18 新增 所属公司 业务员 客户名称-->
          <vxe-table-column
            width="200"
            field="compName"
            title="所属方"
            align="center"
          >
            <template v-slot:header="{ column }">
              <span class="column-title"
                >{{ column.title }} <i style="color: #f00"> * </i></span
              >
            </template>
            <template v-slot="scope">
              <div
                v-if="
                  isInitByOrder == 'seller' ||
                    isInitByOrder == 'buyer' ||
                    fromOrigin == 'chain'
                "
              >
                {{ scope.row.compName }}
              </div>
              <div v-else>
                <div v-if="payType === 1">
                  <platform-corp
                    :row="scope.row"
                    :field="'compName'"
                    :placeholder="'请选择平台企业'"
                    @select="$refs.xTable.updateStatus(scope)"
                    @update="selectCompName"
                    :autoSave="false"
                    v-if="canInsert"
                  ></platform-corp>
                  <div v-else>{{ scope.row.compName }}</div>
                </div>
                <div
                  class="link-text"
                  @click="openPayAccount(scope.row, 'compName')"
                  v-else
                >
                  {{ scope.row.compName ? scope.row.compName : "选择所属方" }}
                </div>
              </div>
            </template>
          </vxe-table-column>
          <!-- <vxe-table-column
              field="salesMan"
              width="105"
              title="业务员"
              align="center"
          >
            <template v-slot="scope">
              <div
                  v-if="
                  isInitByOrder == 'seller' ||
                  isInitByOrder == 'buyer' ||
                  fromOrigin == 'chain'
                "
              >
                {{ scope.row.salesMan }}
              </div>
              <div v-else>
                <sales-man
                    v-if="canInsert"
                    :row="scope.row"
                    :field="'salesMan'"
                    @setSaleMan="setSaleMan"
                ></sales-man>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column
              field="commission"
              width="105"
              title="佣金率(%)"
              align="center"
          >
         </vxe-table-column> -->
          <vxe-table-column
            field="clientName"
            width="150"
            title="客户名称"
            align="center"
          >
            <template v-slot:header="{ column }">
              <span class="column-title"
                >{{ column.title }}
                <i style="color: #f00" v-show="payType === 0"> * </i></span
              >
            </template>
            <template v-slot="{ row }">
              <div
                v-if="
                  isInitByOrder == 'seller' ||
                    isInitByOrder == 'buyer' ||
                    fromOrigin == 'chain'
                "
              >
                {{ row.clientName }}
              </div>
              <div
                class="link-text"
                @click="openChooseAccount(row, 'clientName')"
                v-else
              >
                {{ row.clientName ? row.clientName : "选择客户" }}
              </div>
            </template>
          </vxe-table-column>

          <vxe-table-column width="150" field="payAmount" title="金额">
            <template v-slot:header="{ column }">
              <span class="column-title"
                >{{ column.title }} <i style="color: #f00"> * </i></span
              >
            </template>
            <template v-slot="scope">
              <vxe-input
                v-model="scope.row.payAmount"
                v-on:input="inputPayAmountEvent(scope.row)"
                @input="$refs.xTable.updateStatus(scope)"
                placeholder="必填"
                type="number"
              ></vxe-input>
            </template>
          </vxe-table-column>

          <vxe-table-column width="150" field="payBankCode" title="支付流水号">
            <template v-slot="{ row }">
              <vxe-input
                v-model="row.payBankCode"
                placeholder="选填"
                :disabled="payType === 0"
              ></vxe-input>
            </template>
          </vxe-table-column>
          <vxe-table-column width="120" field="addTime" title="日期">
            <template v-slot:header="{ column }">
              <span class="column-title"
                >{{ column.title }}
                <i style="color: #f00" v-show="payType === 1"> * </i></span
              >
            </template>
            <template v-slot="{ row }">
              <vxe-input
                v-model="row.addTime"
                placeholder="请选择"
                type="date"
                :editable="false"
                :disabled="payType === 0"
                prefix-icon
                transfer
              ></vxe-input>
            </template>
          </vxe-table-column>
          <vxe-table-column width="150" field="note" title="摘要">
            <template v-slot:header="{ column }">
              <span class="column-title"
                >{{ column.title }} <i style="color: #f00"> * </i></span
              >
            </template>
            <template v-slot="{ row }">
              <vxe-input
                v-model="row.note"
                placeholder="必填"
                maxlength="200"
              ></vxe-input>
            </template>
          </vxe-table-column>

          <!-- 承运人 -开始 -->
          <vxe-table-column
            width="200"
            field="paymentsName"
            title="付款企业(人)名称"
          >
            <template v-slot:header="{ column }">
              <span class="column-title"
                >{{ column.title }} <i style="color: #f00"> * </i></span
              >
            </template>
            <template v-slot="{ row, $rowIndex }">
              <div
                class="link-text"
                @click="openBankAccountModal(row, $rowIndex, 'paymentsName')"
              >
                {{
                  row.paymentsName == null || row.paymentsName == ""
                    ? "付款企业(人)银行账户"
                    : row.paymentsName
                }}
              </div>
            </template>
          </vxe-table-column>

          <vxe-table-column
            width="150"
            field="payBank"
            :title="payType === 0 ? '所属公司' : '开户行'"
          >
            <template v-slot:header="{ column }">
              <span class="column-title"
                >{{ column.title }} <i style="color: #f00"> * </i></span
              >
            </template>
          </vxe-table-column>
          <vxe-table-column width="150" field="payAccount" title="付款账号">
            <template v-slot:header="{ column }">
              <span class="column-title"
                >{{ column.title }} <i style="color: #f00"> * </i></span
              >
            </template>
          </vxe-table-column>

          <vxe-table-column
            width="200"
            field="recName"
            title="收款企业(人)名称"
          >
            <template v-slot:header="{ column }">
              <span class="column-title"
                >{{ column.title }} <i style="color: #f00"> * </i></span
              >
            </template>
            <template v-slot="{ row, $rowIndex }">
              <div
                class="link-text"
                @click="openBankAccountModal(row, $rowIndex, 'recName')"
              >
                {{
                  row.recName == null ||
                  row.recName == "" ||
                  row.recName == undefined
                    ? "选择收款企业(人)银行账户"
                    : row.recName
                }}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            width="150"
            field="recBank"
            :title="payType === 0 ? '所属公司' : '开户行'"
          >
            <template v-slot:header="{ column }">
              <span class="column-title"
                >{{ column.title }} <i style="color: #f00"> * </i></span
              >
            </template>
          </vxe-table-column>
          <vxe-table-column width="150" field="recAccount" title="收款账号">
            <template v-slot:header="{ column }">
              <span class="column-title"
                >{{ column.title }} <i style="color: #f00"> * </i></span
              >
            </template>
          </vxe-table-column>
          <!-- 平台跟销售方 结束 -->
          <vxe-table-column field="isDraw" title="自动提现" width="100">
            <template v-slot="{ row, $rowIndex }">
              <vxe-select
                v-model="row.isDraw"
                @change="changeIsDraw(row, $rowIndex)"
                placeholder="请选择"
                :options="isDrawType"
                :disabled="payType === 1"
                transfer
              ></vxe-select>
            </template>
          </vxe-table-column>
          <vxe-table-column field="drawBank" title="提现开户银行" width="150">
            <template v-slot="{ row, $rowIndex }">
              <div
                v-show="row.isDraw === 1"
                class="link-text"
                @click="openBindAccountModal(row, $rowIndex)"
              >
                {{
                  row.drawBank == null || row.drawBank == ""
                    ? "选择提现开户银行"
                    : row.drawBank
                }}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="drawAccount"
            title="提现银行账号"
            width="150"
          >
          </vxe-table-column>
          <vxe-table-column
            width="150"
            field="fileList"
            title="上传附件"
            align="center"
          >
            <template v-slot="{ row }">
              <upload-list
                :row="row"
                :initFileList="row.fileList"
                :view="'packup'"
              ></upload-list>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div>
        <vxe-table
          border
          show-overflow
          keep-source
          ref="fileTable"
          :data="uploadData"
          class="table-upload-style"
          max-height="140"
          :auto-resize="true"
          :edit-config="{ trigger: 'click', mode: 'cell', showIcon: false }"
        >
          <vxe-table-column field="fileList" title="附件">
            <template v-slot="{ row }">
              <div style="padding: 5px 0">
                <upload-list
                  :row="row"
                  :view="'arrange'"
                  ref="uploadList"
                ></upload-list>
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <!--END 线下付款-->
      <div class="footer-wrap">
        <Button
          type="primary"
          @click="impotEvent"
          v-if="payType == 1 && (isImport || isCurImport)"
          >上传导入文件
        </Button>
        <Button status="primary" @click="submitEvent">提交</Button>
        <Button
          type="primary"
          @click="showTempModal"
          v-if="
            payType == 1 &&
              (isHavePermission('payments:createPaymentsSeller') ||
                isHavePermission('payments:createPaymentsSellerLv2')) &&
              !isCurImport &&
              !isImport
          "
          >批量导入
        </Button>
      </div>
    </div>
    <!-- 弹窗 -->
    <!-- 选择关联订单 -->
    <vxe-modal
      v-model="isShowChooseOrder"
      width="1300"
      height="700"
      resize
      remember
      title="选择订单"
    >
      <choose-order
        @choose="chooseOrderEvent"
        ref="refPaymentAboutOrder"
      ></choose-order>
    </vxe-modal>
    <!-- 选择所属方 -->
    <vxe-modal
      v-model="isShowPayAccount"
      width="800"
      height="600"
      resize
      remember
      title="选择所属方"
    >
      <pay-account
        @choose="choosePayAccountEvent"
        ref="choosePayAccount"
      ></pay-account>
    </vxe-modal>

    <!-- 选择企业 -->
    <vxe-modal
      v-model="isShowChooseAccount"
      width="800"
      height="600"
      resize
      remember
      title="选择客户"
    >
      <choose-account
        @choose="chooseAccountEvent"
        ref="chooseAccount"
      ></choose-account>
    </vxe-modal>

    <!-- 选择银行账户 -->
    <vxe-modal
      v-model="isShowBankAccountModal"
      width="900"
      height="600"
      resize
      remember
      :title="bankAccountModalTitle"
      :showHeader="false"
    >
      <bank-account
        @close="closeBankAccount"
        @choose="chooseBankAccount"
        :isShow="isShowBankAccountModal"
        ref="bankAccountModal"
      ></bank-account>
    </vxe-modal>
    <vxe-modal
      v-model="templateVisible"
      title="费用支出流程流程导入"
      width="1000"
      height="650"
      @close="closeTemplate"
      remember
    >
      <import
        @goImport="goImport"
        @close="closeTemplate"
        ref="modalTemplate"
      ></import>
    </vxe-modal>
    <vxe-modal
      v-model="isShowCollectionOrder"
      width="1300"
      height="700"
      resize
      remember
      title="选择订单"
    >
      <about-collection-order
        :chainId="chainId"
        @choose="chooseOrderEvent"
        ref="refCollectionAboutOrder"
      ></about-collection-order>
    </vxe-modal>
    <vxe-modal
      v-model="isShowFinance"
      width="800"
      height="600"
      resize
      remember
      title="选择子账户"
    >
      <finance-account
        @choose="chooseFinanceAccount"
        ref="financeAccount"
      ></finance-account>
    </vxe-modal>
    <vxe-modal
      v-model="isShowBindAccount"
      width="800"
      height="600"
      resize
      remember
      title="选择提现开户银行"
    >
      <bind-account
        @choose="chooseBindAccount"
        ref="BindAccount"
      ></bind-account>
    </vxe-modal>
  </div>
</template>

<script>
import $C from "@/consts/index";
import XLSX from "xlsx";
import $api from "@/apiProvider";
import Auth from "@/utils/auth.js";
import UploadList from "@/components/common/UploadList";
import Account from "@/components/modal/Account";
import PayAccount from "@/components/modal/PayAccount";
import BankAccount from "@/components/modal/PayBankAccount";
import PaymentAboutOrder from "@/components/order/PayAboutOrder";
import { apiRequest } from "@/utils/api";
import {
  getExcelTime,
  paymentFooter,
  showLoading,
  hideLoading,
  showFailMsgList,
  isEmpty,
  isNotEmpty
} from "@/utils/util";
import TableHeader from "@/components/common/TableHeader";
import SalesMan from "@/components/common/SalesMan";
import getAuthOrization from "@/mixin/getAuthOrization";
import DetailHeader from "@/views/procedure/DetailHeader";
import PlatformCorp from "@/components/common/PlatformCorp";
import AboutCollectionOrder from "@/components/order/AboutCollectionOrder";
import Import from "@/components/common/Import"; // 导入
import FinanceAccount from "@/components/modal/FinanceAccount";
import BindAccount from "@/components/modal/BindAccount";

import moment from "moment";

moment.locale("zh-CN");

const assign = o => Object.assign({}, o);

export default {
  mixins: [getAuthOrization],
  name: "CreatePayment",
  components: {
    TableHeader,
    ChooseOrder: PaymentAboutOrder,
    UploadList,
    BankAccount,
    ChooseAccount: Account,
    DetailHeader,
    Import,
    PlatformCorp,
    // SalesMan,
    AboutCollectionOrder,
    FinanceAccount,
    PayAccount,
    BindAccount
  },
  props: {
    cate: {
      type: String,
      default: ""
    },
    isShow: {
      type: Boolean,
      default: false
    },
    // isImport: {
    //   type: Boolean,
    //   default: false,
    // },
    chainId: {
      type: Number
    }
  },
  data() {
    let userInfoValue = {};
    if (Auth.isLogin()) {
      userInfoValue = Auth.getAuth();
    }
    return {
      isImport: false,
      userInfoValue,
      payType: 1,
      formData: {},
      createAction: "createPaymentsSellerAndSellerLv2",
      canInsert: true,
      isShowChooseOrder: false,
      //选择银行账户
      isShowBankAccountModal: false,
      bankAccountModalTitle: "选择银行账户",
      isShowChooseAccount: false, // 选择客户
      isShowPayAccount: false,
      amountListName: "", //关联订单的字段名
      dataTmp: {
        index: "",
        ordersNumb: null,
        addTime: "",
        fileUuidList: [],
        fileList: [],
        note: null,
        operUser: null,
        ordersBuyerAmountList: [],
        ordersSellerAmountList: [],
        ordersSellerLv2sAmountList: [],
        payAccount: null,
        payAmount: "",
        payBank: null,
        payBankCode: null,
        paymentsName: null,
        payCompName: null,
        recAccount: null,
        recBank: null,
        recName: null,
        recCompName: null,
        rateManage: null,
        unusedAmount: 0,
        usedAmount: 0,
        compName: "",
        isOrderCompName: false,
        salesMan: "",
        isOrdersalesMan: false,
        clientName: "",
        isOrderClientName: false,
        ordersList: [],
        isDraw: 0,
        drawBank: null,
        drawAccount: null
      },
      tableData: [],
      editRules: {
        compName: [{ validator: this.requireValid }],
        // ordersNumb: [{ validator: this.requireValid }],
        payAmount: [{ validator: this.requireValid }],
        addTime: [{ validator: this.requireValid }],
        note: [{ validator: this.requireValid }],
        paymentsName: [{ validator: this.requireValid }],
        recName: [{ validator: this.requireValid }],
        // salesMan: [{ validator: this.requireValid }],
        clientName: [{ validator: this.requireValid }],
        drawBank: [{ validator: this.requireValid }],
        payBank: [{ validator: this.requireValid }],
        payAccount: [{ validator: this.requireValid }],
        recBank: [{ validator: this.requireValid }],
        recAccount: [{ validator: this.requireValid }]
      },
      platformCompMap: {},
      platformCompanyId: null,
      // clientId: null,
      // buyerId: null,
      // sellerId: null,
      paymentType: null,
      orderInfo: null,
      orderType: null,
      isBuyerLine: false, // 是否托运人线上支付
      fromOrigin: null,
      initRecord: {},
      isSubmit: false,
      isChangeType: false,
      flowTempletId: 2,
      isLoaded: false,
      isCurImport: false,
      templateVisible: false,
      isinitByOrder: false,
      uploadData: [
        {
          fileList: null
        }
      ],
      isShowCollectionOrder: false,
      salesManData: null,
      isShowFinance: false,
      isInitByOrder: "",
      compNameType: 0,
      isDrawType: [
        {
          label: "是",
          value: 1
        },
        {
          label: "否",
          value: 0
        }
      ], // 是否提现
      isShowBindAccount: false
    };
  },
  watch: {
    isShow: {
      deep: true,
      immediate: true,
      handler: function(val, oldVal) {
        if (val == false && oldVal == true) {
          if (isNotEmpty(this.$refs.xTable)) {
            this.$refs.xTable.clearValidate();
            this.updateFooterEvent();
          }
          this.payType = 1;
          this.tableData = [];
          this.uploadData = [];
          let fileObj = {
            fileList: null
          };
          this.uploadData.push(fileObj);
          this.$refs.uploadList.init();
          // debugger
          this.canInsert = true;
          this.createAction = "createPaymentsSellerAndSellerLv2";
          this.isSubmit = false;
          this.isChangeType = false;
          this.isLoaded = false;
          this.isinitByOrder = false;
          this.salesManData = null;
          this.isImport = false;
          this.isInitByOrder = "";
        }
        if (val == true) {
          // this.insertEvent();
          this.getFlowData();
          this.resetFormData();
        }
      }
    },
    cate: {
      deep: true,
      immediate: true,
      handler: function(val, oldVal) {
        switch (val) {
          case "Collection":
            this.amountListName = "ordersBuyerAmountList";
            break;
          case "Payment":
            this.amountListName = "ordersSellerAmountList";
            break;
          case "SellerPayment":
            this.amountListName = "ordersSellerLv2sAmountList";
            break;
        }
      }
    },
    payType: {
      deep: true,
      immediate: true,
      handler: function(val, oldVal) {
        if (val !== oldVal && oldVal !== undefined) {
          this.changeType();
        }
      }
    }
  },
  methods: {
    getPayObj(val) {
      this.formData = val;
      this.payType = val.type;
    },
    getFlowData() {
      let obj = { flowTempletId: this.flowTempletId };
      $api.flowInstance.createFlowModel
        .GET({
          params: obj
        })
        .then(res => {
          if (res.status === 1) {
            this.formData = res.data;
            this.isLoaded = true;
          } else {
            this.$XModal.confirm(res.message).then(() => {
              this.$emit("close");
            });
          }
        });
    },
    changeIsDraw(row, i) {
      let tableData = this.$refs.xTable.getTableData().fullData;
      tableData[i].drawBank = null;
      tableData[i].drawAccount = null;
    },
    changeType() {
      this.salesManData = null;
      this.isChangeType = true;
      this.createAction =
        this.payType === 0
          ? "createPaymentsOnline"
          : "createPaymentsSellerAndSellerLv2";
      this.$refs.xTable.remove();
      if (this.orderType === 1) {
        if (this.payType === 0) {
          this.isBuyerLine = true;
        } else {
          this.isBuyerLine = false;
        }
      }

      if (this.fromOrigin === "chain") {
        this.initByChainId(this.chainId);
        // this.insertEvent();
      } else if (this.fromOrigin === "order") {
        this.initByOrderInfo(this.orderInfo, this.orderType);
      } else {
        this.insertEvent();
      }

      // if(this.isInitByOrder === "buyer") {
      //   if(this.payType === 0) {
      //     this.isInitByOrder = "seller"
      //   } else {
      //     this.isInitByOrder = "buyer"
      //   }
      // }
    },
    initByChainId(chainId) {
      this.fromOrigin = "chain";
      let orderInfo = this.getBuyerOrderInfoByChainId(chainId);
      this.insertEvent();
    },
    resetFormData() {
      // this.formData.title = `费用支出流程- ${
      //   this.userInfoValue.username
      // } - ${moment(new Date()).format("YYYY-MM-DD")}`;
      // this.formData.man = this.userInfoValue.username;
      // this.formData.applyTime = new Date();
      this.payType = 1;
    },
    //查托运人订单
    async getBuyerOrderInfoByChainId(chainId) {
      let orderInfo = null;
      let res = await $api.order.post("queryOrdersBuyerList", {
        chainId: chainId,
        page: 1
      });
      if (res.status == 1 && res.data.rows && res.data.rows.length > 0) {
        let orderRes = await $api.order.post("queryOrdersBuyerDetail", {
          id: res.data.rows[0].id
        });
        if (orderRes.status == 1) {
          orderInfo = orderRes.data;
        }
      }
      return orderInfo;
    },
    initByOrderInfo(orderInfo, orderType = 0) {
      this.fromOrigin = "order";
      this.orderInfo = orderInfo;
      this.orderType = orderType;

      // console.log(orderInfo, "orderInfo");
      // console.log("创建收付款 通过 订单号初始化 - 开始", orderInfo, this.cate);
      // debugger
      this.insertEvent();
      this.currentRow = this.$refs.xTable.getTableData().tableData[0];
      //托运人 承运人 取订单号
      if (orderType === 1) {
        this.isInitByOrder = "buyer";
      } else {
        this.isInitByOrder = "seller";
      }
      //&& this.payType === 1
      if (orderType === 1) {
        // 托运人订单
        // 托运人订单线下支付
        this.currentRow.ordersNumb = null;
        this.currentRow.compName = null;
        this.currentRow.platformCompanyId = null;
        // if (isNotEmpty(orderInfo.platformCompanyId)) {
        //   this.currentRow.compName = orderInfo.platformCompany;
        //   this.currentRow.platformCompanyId = orderInfo.platformCompanyId;
        // }
        this.currentRow.salesMan = null;
        this.currentRow.salesManId = null;
        this.currentRow.commission = null;
        this.currentRow.clientName = null;
        this.currentRow.paymentsName = null;
        this.currentRow.payBank = null;
        this.currentRow.payAccount = null;
        this.currentRow.recBank = null;
        this.currentRow.recName = null;
        this.currentRow.recAccount = null;
        this.currentRow.payCompName = null;
        this.currentRow.recCompName = null;
        this.currentRow.payAmount = null;
        this.currentRow.note = null;
      } else {
        // console.log(orderInfo, 'orderInfoorderInfoorderInfo');
        // debugger
        this.currentRow.payAmount = null;
        this.currentRow.note = null;
        if (this.cate === "Collection" || this.isBuyerLine) {
          orderInfo.ordersNumb = orderInfo.buyerOrdersNum;
        } else {
          orderInfo.ordersNumb = orderInfo.sellerOrdersNum;
        }
        orderInfo.ordersId = orderInfo.id;
        // ?????
        // orderInfo.id = null;
        orderInfo.paymentType = orderType;
        // console.log(orderInfo, 'orderInfo');
        // debugger
        // aboutAmount: 1000
        // buyerName: "携船网航运科技有限公司"
        // chainNum: "T2104080112"
        // id: 3064
        // ordersId: "3064"
        // ordersNumb: "S2104080112"
        // salesManId: 172
        // salesManName: "携船网"
        // sellerName: "测试货运"

        let selOrderArr = [];
        let selOrderObj = {
          aboutAmount: null,
          buyerName: orderInfo.buyerName,
          id: orderInfo.ordersId,
          ordersId: orderInfo.ordersId,
          ordersNumb: orderInfo.ordersNumb,
          salesManId: orderInfo.salesMan,
          salesManName: orderInfo.salesManName,
          sellerName: orderInfo.sellerName,
          paymentType: orderInfo.paymentType,
          buyerId: orderInfo.buyerId,
          sellerId: orderInfo.sellerId
        };
        selOrderArr.push(selOrderObj);

        let firstLine = this.chooseOrderEvent(selOrderArr, 0);
        firstLine.then(() => {
          this.initRecord = this.currentRow;
          this.$refs.xTable.reloadData([this.initRecord]);
        });
        // console.log(orderInfo);
        // debugger
        if (orderInfo.paymentType == 3) {
          if (isNotEmpty(orderInfo.buyerName)) {
            // this.currentRow.compName = orderInfo.buyerName;
            // this.currentRow.platformCompanyId = orderInfo.buyerId;
            // this.platformCompanyId = orderInfo.buyerId;
            this.currentRow.compName = orderInfo.buyerName;
            this.currentRow.platformCompany = orderInfo.platformCompany;
            this.currentRow.platformCompanyId = orderInfo.platformCompanyId;
            this.platformCompanyId = orderInfo.platformCompanyId;
          }
        } else {
          if (isNotEmpty(orderInfo.platformCompanyId)) {
            this.currentRow.compName = orderInfo.platformCompany;
            this.currentRow.platformCompany = orderInfo.platformCompany;
            this.currentRow.platformCompanyId = orderInfo.platformCompanyId;
            this.platformCompanyId = orderInfo.platformCompanyId;
          }
        }

        if (isNotEmpty(orderInfo.salesMan)) {
          this.currentRow.salesMan = orderInfo.salesManName;
          this.currentRow.salesManId = orderInfo.salesMan;
        }
        if (isNotEmpty(orderInfo.rateManage)) {
          this.currentRow.rateManage = orderInfo.rateManage;
          this.currentRow.commission = orderInfo.rateManage;
        }
      }
      // this.canInsert = orderType === 1 ? true : false;
      // 记录第一条数据 新增时添加
      // this.initRecord = {
      //   ordersNumb: this.currentRow.ordersNumb, //承运人订单号
      //   ordersId: this.currentRow.ordersId,
      //   salesMan: this.currentRow.salesMan,
      //   salesManId: this.currentRow.salesManId,
      //   commission: this.currentRow.commission,
      //   compName: this.currentRow.compName,
      //   platformCompanyId: this.currentRow.platformCompanyId,
      //   clientName: this.currentRow.clientName,
      //   paymentsName: this.currentRow.paymentsName,
      //   payBank: this.currentRow.payBank,
      //   payAccount: this.currentRow.payAccount,
      //   recBank: this.currentRow.recBank,
      //   recName: this.currentRow.recName,
      //   recAccount: this.currentRow.recAccount,
      // };
      // console.log(this.initRecord, 'this.initRecord');
      // debugger
      // this.$refs.xTable.reloadData([this.currentRow]);

      // console.log(
      //   "创建收付款 通过 订单号初始化 - 结束",
      //   this.cate,
      //   this.currentRow
      // );
    },
    initByCate(cate) {
      this.fromOrigin = "cate";
      this.insertEvent();
      // console.log(this.cate, cate);
    },
    async requireValid(e) {
      if (e.columnIndex == 3 && isEmpty(e.row.compName)) {
        return Promise.reject(new Error("请先选择所属公司"));
      }
      if (
        this.payType === 1 &&
        e.columnIndex == 7 &&
        isEmpty(e.row.payAmount)
      ) {
        return Promise.reject(new Error("请先填写付款金额"));
      }
      // if (
      //   e.column.title == "提现开户银行" &&
      //   e.row.isDraw === 1 &&
      //   isEmpty(e.row.drawBank)
      // ) {
      //   return Promise.reject(new Error("请选择提现银行"));
      // }
      // if (this.payType === 0 && e.columnIndex == 3 && isEmpty(e.row.compName)) {
      //   return Promise.reject(new Error("所属公司为空，请填写正确的订单号"));
      // }
      // if (this.payType === 0 && e.columnIndex == 4 && isEmpty(e.row.salesMan)) {
      //   return Promise.reject(new Error("请选择业务员"));
      // }
      //  if (this.payType === 0 && isEmpty(e.row.ordersNumb)) {
      //   return Promise.reject(new Error("请选择订单"));
      // }
      // if (this.payType === 1 && e.columnIndex == 3 && isEmpty(e.row.compName)) {
      //   return Promise.reject(new Error("所属公司不能为空"));
      // }
      // if (e.columnIndex == 7 && !(e.row.payAmount > 0)) {
      //   return Promise.reject(new Error("请先填写付款金额"));
      // }
      if (
        isNotEmpty(e.row.compName) &&
        e.row.aboutAmount > 0 &&
        e.columnIndex == 2 &&
        this.isImport &&
        isEmpty(e.row.ordersNumb)
      ) {
        return Promise.reject(new Error("导入必须填写订单号"));
      }
      if (isEmpty(e.cellValue)) {
        if (
          (e.columnIndex === 7 && this.payType === 0) ||
          (e.columnIndex === 2 && this.payType === 1) ||
          (e.columnIndex === 4 && this.payType === 1) ||
          (e.column.title == "提现开户银行" && e.row.isDraw !== 1)
        ) {
          console.log("线上支付不需要填日期");
        } else {
          return Promise.reject(new Error(e.column.title + "必填"));
        }
      }
    },
    showTempModal() {
      this.$refs.modalTemplate.setExport("708费用支出流程导入模板.xls");
      this.templateVisible = true;
    },
    closeTemplate() {
      this.templateVisible = false;
    },
    goImport() {
      this.isShowCreateInvoice = true;
      this.isCurImport = true;
      this.templateVisible = false;
    },
    async impotEvent() {
      await this.initPlatCompMap();
      this.$refs.xTable
        .readFile({
          types: ["xls", "xlsx"]
        })
        .then(evnt => {
          showLoading();
          const tableData = [];
          const importIds = [];
          this.isImport = true;
          const files = evnt.target.files;
          const fileReader = new FileReader();
          fileReader.onload = async ev => {
            const data = ev.target.result;
            const workbook = XLSX.read(data, { type: "binary" });
            const csvData = XLSX.utils.sheet_to_csv(
              Object.values(workbook.Sheets)[0]
            );
            // 解析数据
            let xlsxData = csvData.split("\n");
            //删除xlsx列名
            xlsxData.splice(0, 1);
            xlsxData.forEach(vRow => {
              if (vRow) {
                const vCols = vRow.split(",");
                importIds.push(vCols[1]);
                let item = {
                  index: vCols[0] ? vCols[0].trim() : null, //需要
                  ordersNumb: vCols[1] ? vCols[1].trim() : null, //承运人订单号
                  compName: vCols[2] ? vCols[2].trim() : null,
                  // salesMan: vCols[3] ? vCols[3].trim() : null,
                  clientName: vCols[3] ? vCols[3].trim() : null,
                  payAmount: vCols[4] ? vCols[4].trim() : null, //付款金额
                  payBankCode: vCols[5] ? vCols[5].trim() : null, //支付凭证流水号
                  addTime: getExcelTime(vCols[6]), //收款日期
                  note: vCols[7] ? vCols[7].trim() : null, //摘要
                  isOrderCompName: false,
                  isOrdersalesMan: false,
                  isOrderClientName: false,
                  paymentsName: vCols[8] ? vCols[8].trim() : null, //付款企业（人）名称
                  payBank: vCols[9] ? vCols[9].trim() : null, //开户行
                  payAccount: vCols[10] ? vCols[10].trim() : null, //银行卡号
                  recName: vCols[11] ? vCols[11].trim() : null, //收款企业（人）名称
                  recBank: vCols[12] ? vCols[12].trim() : null, //开户行
                  recAccount: vCols[13] ? vCols[13].trim() : null //银行卡号
                };

                item.platformCompanyId = this.platformCompMap[item.compName];
                tableData.push(item);
              }
            });
            let res = {};
            if (importIds.length == 0) {
              res.status == 1;
              res.data = [];
            } else {
              res = await $api.ordersSeller.post(
                "queryOrdersSellerSalesInfoList",
                importIds
              );
              // if (this.cate == 'Sales') {
              //   res = await $api.ordersBuyer.post('queryOrdersBuyerSalesInfoList', importIds)
              // } else {
              //   res = await $api.ordersSeller.post('queryOrdersSellerSalesInfoList', importIds)
              // }
            }
            if (res.status == 1) {
              let orders = res.data;
              // console.log(orders, 'orders');
              // debugger
              tableData.map(i => {
                // console.log(i, 'iiiiiii');
                if (i.ordersNumb) {
                  let orderInfo = orders.find(
                    j => j.ordersNum === i.ordersNumb
                  );
                  // console.log(orderInfo);
                  // debugger
                  if (isNotEmpty(orderInfo)) {
                    // i.ownName = orderInfo.ownName ? orderInfo.ownName : "";
                    if (isEmpty(i.platformCompanyId)) {
                      i.platformCompanyId = orderInfo.ownPlatformCompanyId
                        ? orderInfo.ownPlatformCompanyId
                        : "";
                    }
                    if (isEmpty(i.clientName)) {
                      i.clientName = orderInfo.clientName
                        ? orderInfo.clientName
                        : "";
                    }
                    if (isEmpty(i.compName)) {
                      i.compName = orderInfo.ownName ? orderInfo.ownName : "";
                    }
                    if (isEmpty(i.salesMan)) {
                      i.salesMan = orderInfo.salesMan ? orderInfo.salesMan : "";
                      i.salesManId = orderInfo.salesManId
                        ? orderInfo.salesManId
                        : "";
                      i.isOrderSalesMan = true;
                    }
                    if (
                      i.salesMan == orderInfo.salesMan &&
                      i.compName == orderInfo.ownName
                    ) {
                      i.commission = i.rateManage = orderInfo.rateManage
                        ? orderInfo.rateManage
                        : "";
                    }
                    i.ownName = orderInfo.ownName ? orderInfo.ownName : "";
                    i.paymentType = orderInfo.orderType
                      ? orderInfo.orderType
                      : "";
                    this.amountListName =
                      orderInfo.orderType == 2
                        ? "ordersSellerAmountList"
                        : "ordersSellerLv2sAmountList";
                    i[this.amountListName] = [
                      {
                        ordersNum: i.ordersNumb,
                        ordersNumb: i.ordersNumb,
                        aboutAmount: i.payAmount,
                        paymentType: orderInfo.orderType
                      }
                    ];
                  }
                }
              });
            }
            // console.log(tableData, 'tableData');
            // debugger
            this.tableData = tableData;
            this.updateFooterEvent();
            setTimeout(() => {
              hideLoading();
            }, 1000);
          };
          fileReader.readAsBinaryString(files[0]);
        });
    },
    insertEvent() {
      // debugger
      if (isEmpty(this.$refs.xTable)) return;
      let tableData = this.$refs.xTable.getTableData().tableData;
      // console.log(tableData[0], 'tableData[0]');
      // debugger
      this.$refs.xTable.clearValidate();
      let record = assign(this.dataTmp);
      // console.log(this.canInsert, "this.canInsert");
      // debugger;
      // this.payType !== 0
      if (this.isInitByOrder == "seller") {
        //不能新增的情况下 都是复制第一条的
        if (tableData.length > 0) {
          // console.log(this.initRecord, "this.initRecord");
          // debugger;
          let amountList;
          if (
            tableData[0][this.amountListName] &&
            tableData[0][this.amountListName].length > 0
          ) {
            amountList = [assign(tableData[0][this.amountListName][0])];
          }
          // let amountList = [assign(tableData[0][this.amountListName][0])];
          if (this.payType === 1) {
            record = Object.assign(record, {
              ordersNumb: this.initRecord.ordersNumb, //承运人订单号
              ordersId: this.initRecord.ordersId,
              salesMan: this.initRecord.salesMan,
              salesManId: this.initRecord.salesManId,
              commission: this.initRecord.commission,
              rateManage: this.initRecord.commission,
              compName: this.initRecord.compName,
              platformCompanyId: this.initRecord.platformCompanyId,
              clientName: this.initRecord.clientName,
              paymentsName: null,
              payCompName: null,
              payBank: null,
              payAccount: null,
              recBank: null,
              recName: null,
              recAccount: null,
              recCompName: null,
              [this.amountListName]: amountList,
              isDraw: 0,
              drawBank: null,
              drawAccount: null
            });
          } else {
            record = Object.assign(record, {
              ordersNumb: this.initRecord.ordersNumb, //承运人订单号
              ordersId: this.initRecord.ordersId,
              salesMan: this.initRecord.salesMan,
              salesManId: this.initRecord.salesManId,
              commission: this.initRecord.commission,
              rateManage: this.initRecord.commission,
              compName: this.initRecord.compName,
              platformCompanyId: this.initRecord.platformCompanyId,
              clientName: this.initRecord.clientName,
              paymentsName: this.initRecord.paymentsName,
              payCompName: this.initRecord.payCompName,
              payBank: this.initRecord.payBank,
              payAccount: this.initRecord.payAccount,
              recBank: this.initRecord.recBank,
              recName: this.initRecord.recName,
              recAccount: this.initRecord.recAccount,
              recCompName: this.initRecord.recCompName,
              [this.amountListName]: amountList,
              isDraw: 0,
              drawBank: null,
              drawAccount: null
            });
          }
        }
      } else {
        // debugger
        record = {
          ordersNumb: null, //承运人订单号
          ordersId: null,
          salesMan: null,
          salesManId: null,
          commission: null,
          compName: null,
          platformCompanyId: null,
          clientName: null,
          paymentsName: null,
          payCompName: null,
          recCompName: null,
          payBank: null,
          payAccount: null,
          recBank: null,
          recName: null,
          recAccount: null,
          rateManage: null,
          isDraw: 0,
          drawBank: null,
          drawAccount: null
        };
      }
      record.index = tableData.length + 1;
      record.fileList = [];
      record.fileUuidList = [];
      this.$refs.xTable.insertAt(record, -1);
      this.$refs.xTable.updateStatus();
      this.updateFooterEvent();
    },
    async removeEvent() {
      let checkboxRecords = this.$refs.xTable.getCheckboxRecords();
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({ message: "没有选择" });
        return;
      }
      // if (this.$refs.xTable.getTableData().tableData.length === 1) {
      //   this.$XModal.message({ message: "只剩最后一条了，无法删除。" });
      //   return;
      // }
      let confirmRes = await this.$XModal.confirm(
        "删除后不可恢复",
        "是否删除？"
      );
      if (confirmRes == "confirm") {
        this.$refs.xTable.removeCheckboxRow();
        this.$refs.xTable.updateStatus();
      }
    },
    copyEvent() {
      let checkboxRecords = this.$refs.xTable.getCheckboxRecords();
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({ message: "没有选择" });
        return;
      }
      let newRecords = [];
      checkboxRecords.forEach(item => {
        let newItem = assign(item);
        let newAmountList = [];
        if (newItem[this.amountListName]) {
          newItem[this.amountListName].forEach(i => {
            newAmountList.push(assign(i));
          });
          newItem[this.amountListName] = newAmountList;
        }

        console.log(newItem);
        newRecords.push(assign(newItem));
      });
      this.$refs.xTable.insertAt(newRecords, -1);
      this.$refs.xTable.updateStatus();
    },
    cellClickEvent(e) {
      this.$refs.xTable.clearValidate();
    },
    async selectCompName(row, id, name) {
      this.currentRow = row;
      // 选择平台清空收付款信息
      if (this.payType === 0) {
        this.currentRow.paymentsName = null;
        this.currentRow.payBank = null;
        this.currentRow.payAccount = null;
        this.currentRow.recBank = null;
        this.currentRow.recName = null;
        this.currentRow.recAccount = null;
        this.currentRow.payCompName = null;
        this.currentRow.recCompName = null;
      }

      if (this.salesManData && this.salesManData.rateList) {
        let arr = [];
        arr = this.salesManData.rateList.filter(item => item.compName == name);
        this.currentRow.commission = arr.length == 1 ? arr[0].rateManage : null;
      }
      if (
        isNotEmpty(row.compName) &&
        row.compName != name &&
        isNotEmpty(row[this.amountListName])
      ) {
        let confirmRes = await this.$XModal.confirm(
          "更换所属平台公司将清空关联订单",
          "是否更换"
        );
        if (confirmRes === "confirm") {
          row[this.amountListName] = [];
          row.ordersNumb = "";
        } else {
          return;
        }
      }
      row.platformCompanyId = id;
      row.compName = name;
    },
    async setSaleMan(data, status) {
      this.salesManData = data;
      if (isNotEmpty(this.currentRow) && data && data.rateList) {
        let arr = [];
        arr = data.rateList.filter(
          item => item.compName == this.currentRow.compName
        );
        this.currentRow.commission = arr.length == 1 ? arr[0].rateManage : null;
      }
    },
    async openOrderModal(row) {
      this.type = this.payType;
      // let cate = this.type === 0 ? "Collection" : "Payment";
      let cate = "Payment";
      this.currentRow = row;
      if (this.type === 0) {
        // 线上
        if (
          isNotEmpty(row.compName) ||
          this.isInitByOrder == "buyer" ||
          this.fromOrigin === "chain"
        ) {
          this.isShowChooseOrder = true;
          this.$refs.refPaymentAboutOrder.init(
            this.type,
            cate,
            0,
            row.payAmount,
            row[this.amountListName],
            this.chainId,
            row.compName,
            row.platformCompanyId
          );
        } else {
          await this.$refs.xTable.clearValidate();
          await this.$refs.xTable.validate(row, err => {});
        }
      } else {
        // 线下
        if (this.isInitByOrder == "buyer" || this.fromOrigin === "chain") {
          // 供应链  购方
          this.isShowChooseOrder = true;
          this.$refs.refPaymentAboutOrder.init(
            this.type,
            cate,
            0,
            row.payAmount,
            row[this.amountListName],
            this.chainId,
            row.compName,
            row.platformCompanyId
          );
        } else {
          if (isNotEmpty(row.payAmount) && isNotEmpty(row.compName)) {
            this.isShowCollectionOrder = true;
            this.$refs.refCollectionAboutOrder.init(
              this.cate,
              0,
              row.payAmount,
              row[this.amountListName],
              row.platformCompanyId,
              "",
              row.compName
            );
          } else {
            await this.$refs.xTable.clearValidate();
            await this.$refs.xTable.validate(row, err => {});
          }
        }

        // if (
        //   (isNotEmpty(row.payAmount) && isNotEmpty(row.compName)) ||
        //   this.isInitByOrder == "buyer" ||
        //   this.fromOrigin === "chain"
        // ) {
        //   if (
        //     (this.isInitByOrder == "buyer" || this.fromOrigin === "chain") &&
        //     isEmpty(row.payAmount)
        //   ) {
        //     this.$XModal.message({
        //       message: "请先填写金额",
        //     });
        //     return;
        //   }
        //   this.isShowCollectionOrder = true;
        //   this.$refs.refCollectionAboutOrder.init(
        //     this.cate,
        //     0,
        //     row.payAmount,
        //     row[this.amountListName],
        //     row.platformCompanyId,
        //     "",
        //     row.compName
        //   );
        // } else {
        //   await this.$refs.xTable.clearValidate();
        //   await this.$refs.xTable.validate(row, (err) => {});
        // }
      }
    },
    openPayAccount(row, field) {
      this.isShowPayAccount = true;
      this.currentRow = row;
      this.currentChooseColumn = field;
      this.$refs.choosePayAccount.init();
    },
    openChooseAccount(row, field) {
      this.isShowChooseAccount = true;
      this.currentRow = row;
      this.currentChooseColumn = field;
      this.$refs.chooseAccount.init();
    },
    async choosePayAccountEvent(account, type) {
      this.isShowPayAccount = false;
      this.$refs.xTable.clearValidate(this.currentChooseColumn);
      this.compNameType = type;
      let name = type == 0 ? account.name : account.userName;
      if (
        isNotEmpty(this.currentRow.compName) &&
        this.currentRow.compName != name &&
        isNotEmpty(this.currentRow.ordersList)
      ) {
        let confirmRes = await this.$XModal.confirm(
          "更换所属平台公司将清空关联订单",
          "是否更换"
        );
        if (confirmRes === "confirm") {
          this.currentRow[this.amountListName] = [];
          this.currentRow.ordersList = [];
          this.currentRow.ordersNumb = null;
          this.currentRow.commission = null;
        } else {
          return;
        }
      }

      this.currentRow.compName = name;

      if (type == 0) {
        this.currentRow.platformCompanyId = account.id;
        // 选择平台企业获取业务员佣金
        if (this.salesManData && this.salesManData.rateList) {
          let arr = [];
          arr = this.salesManData.rateList.filter(
            item => item.compName == account.name
          );
          this.currentRow.commission =
            arr.length == 1 ? arr[0].rateManage : null;
        }
      } else {
        this.currentRow.platformCompanyId = null;
      }
      // 选择平台清空收付款信息
      if (this.payType === 0) {
        this.currentRow.paymentsName = null;
        this.currentRow.payBank = null;
        this.currentRow.payAccount = null;
        this.currentRow.recBank = null;
        this.currentRow.recName = null;
        this.currentRow.recAccount = null;
        this.currentRow.payCompName = null;
        this.currentRow.recCompName = null;
      }
    },
    chooseAccountEvent(account, type) {
      // console.log("chooseAccountEvent", account);
      this.currentRow[this.currentChooseColumn] = account.userName;
      this.isShowChooseAccount = false;
      this.$refs.xTable.clearValidate(this.currentChooseColumn);
      // 选择平台清空收付款信息
      // if (this.payType === 0) {
      //   this.currentRow.paymentsName = null;
      //   this.currentRow.payBank = null;
      //   this.currentRow.payAccount = null;
      //   this.currentRow.recBank = null;
      //   this.currentRow.recName = null;
      //   this.currentRow.recAccount = null;
      //   this.currentRow.payCompName = null;
      //   this.currentRow.recCompName = null;
      // }
    },
    async chooseOrderEvent(amountList, usedAmount) {
      // 选择订单自动带入数据
      this.isShowChooseOrder = false;
      this.isShowCollectionOrder = false;
      this.$refs.xTable.clearValidate("ordersNumb");
      // 传递给银行查询ID
      // this.platformCompanyId = amountList[0].platformCompanyId;
      // console.log(amountList);
      // debugger

      this.currentRow.platformCompanyId = amountList[0].platformCompanyId;
      if (this.payType === 0) {
        if (amountList[0].paymentType === 3) {
          this.currentRow.buyerName = amountList[0].buyerName;
          this.currentRow.compName = amountList[0].buyerName;
          this.currentRow.platformCompany = amountList[0].platformCompany;
          this.currentRow.platformCompanyId =
            amountList[0].ownPlatformCompanyId;
        } else {
          this.currentRow.buyerName = amountList[0].platformCompany;
          this.currentRow.compName = amountList[0].platformCompany;
          this.currentRow.platformCompany = amountList[0].platformCompany;
          this.currentRow.platformCompanyId = amountList[0].platformCompanyId;
        }
      } else {
        if (this.fromOrigin == "chain") {
          // console.log(amountList[0]);
          this.currentRow.compName = amountList[0].buyerName;
        } else if (this.isInitByOrder == "buyer") {
          this.currentRow.compName = amountList[0].buyerName;
          this.currentRow.buyerName = amountList[0].buyerName;
        } else {
          this.currentRow.buyerName = amountList[0].buyerName;
        }
      }

      // this.platformCompanyId = amountList[0].platformCompanyId;
      // if (amountList[0].paymentType === 3) {
      //   this.currentRow.compName = amountList[0].buyerName;
      //   this.currentRow.platformCompanyId = amountList[0].ownPlatformCompanyId;
      // } else {
      //   this.currentRow.compName = amountList[0].platformCompany;
      //   this.currentRow.platformCompanyId = amountList[0].platformCompanyId;
      // }

      // this.paymentType = amountList[0].paymentType;

      //关联订单数据
      // this.currentRow.usedAmount = usedAmount;

      // 重新选择订单 LIST 清空
      this.currentRow.ordersBuyerAmountList = [];
      this.currentRow.ordersSellerAmountList = [];
      this.currentRow.ordersSellerLv2sAmountList = [];
      this.currentRow.ordersList = [];
      let amountListName;
      // console.log(amountList);
      // debugger
      amountList.forEach(item => {
        let firWord = item.ordersNumb.substr(0, 1);
        let ordersType;
        if (firWord == "G") {
          amountListName = "ordersBuyerAmountList";
          ordersType = 1;
        } else if (firWord == "S") {
          amountListName = "ordersSellerAmountList";
          ordersType = 2;
        } else {
          amountListName = "ordersSellerLv2sAmountList";
          ordersType = 3;
        }
        let curRow = Object.assign(item, {
          ordersType,
          ordersNum: item.ordersNumb
        });

        // 只选择一个订单，带入客户名称，业务员，佣金率
        if (amountList.length === 1) {
          this.currentRow.ordersNumb = amountList[0].ordersNumb;
          this.currentRow.salesMan = amountList[0].salesManName;
          if (isNotEmpty(amountList[0].rateManage)) {
            this.currentRow.commission = `${amountList[0].rateManage}`;
            this.currentRow.rateManage = `${amountList[0].rateManage}`;
          } else {
            this.currentRow.commission = null;
            this.currentRow.rateManage = null;
          }
          // 选择多条订单时不带入客户
          if (
            amountList[0].paymentType === 2 ||
            amountList[0].paymentType === 3 ||
            amountList[0].ordersType == 2 ||
            amountList[0].ordersType == 3
          ) {
            // 承运人订单客户为承运人,实际承运人订单为承运人
            this.currentRow.clientName = amountList[0].sellerName;
          } else {
            // 托运人订单客户为托运人， 实际承运人订单为托运人
            this.currentRow.clientName = amountList[0].buyerName;
          }
        } else {
          this.currentRow.ordersNumb = "";
        }

        // console.log(curRow);
        // debugger
        // let ordersListRow = Object.assign(item, { ordersNum: item.ordersNumb, ordersType });
        this.currentRow.ordersList.push(curRow);
        this.currentRow[amountListName].push(curRow);
      });
      // console.log(this.currentRow);
      // debugger
      // if (amountList && amountList[0].paymentType === 2) {
      //   amountListName = "ordersSellerAmountList";
      // } else if (amountList && amountList[0].paymentType === 3) {
      //   amountListName = "ordersSellerLv2sAmountList";
      // } else if (amountList && amountList[0].paymentType === 1) {
      //   amountListName = "ordersBuyerAmountList";
      // }
      // this.currentRow[amountListName] = amountList;
      // console.log(this.currentRow[this.amountListName], 'this.currentRow');
      // if (amountList.length == 1) {
      //   this.currentRow.ordersNumb = amountList[0].ordersNumb;
      // } else {
      //   this.currentRow.ordersNumb = "";
      // }

      // 选择订单重置银行信息
      this.currentRow.payBank = null;
      this.currentRow.paymentsName = null;
      this.currentRow.payAccount = null;
      this.currentRow.recBank = null;
      this.currentRow.recName = null;
      this.currentRow.recAccount = null;
      this.currentRow.payCompName = null;
      this.currentRow.recCompName = null;

      // 线上支付自动带入银行账户信息
      if (this.payType === 0) {
        console.log("线上支付自动带入银行账户信息", this.currentRow);
        let path = "api/finance/";
        let action = "cebBusiMem/queryMemList";
        let params = {};
        params.busiSubjectId = this.platformCompanyId;
        // console.log(this.currentRow, "this.currentRow.ordersBuyerAmountList");
        // console.log(amountList[0], 'amountList[0]');
        // debugger
        if (amountList && amountList[0].paymentType === 1) {
          params.subjectId = this.currentRow.ordersBuyerAmountList[0].buyerId;
        } else if (amountList && amountList[0].paymentType === 2) {
          params.subjectId = this.currentRow.ordersSellerAmountList[0].buyerId;
        } else if (amountList && amountList[0].paymentType === 3) {
          params.subjectId = this.currentRow.ordersSellerLv2sAmountList[0].buyerId;
        }
        switch (amountList[0].paymentType) {
          case 1:
            params.subjectType = 1;
            break;
          case 2:
            params.subjectType = 0;
            break;
          case 3:
            params.subjectType = 1;
        }
        let res = await apiRequest(path, action, params);
        if (res.status === 1) {
          if (res.data.rows.length < 1) {
            this.$XModal.message({
              message: "付款企业或者个人未绑定子账户，请先绑定子账户"
            });
            return;
          } else {
            let arr = res.data.rows.filter(item => {
              return item.busiSubjectName == this.currentRow.platformCompany;
            });
            // console.log(arr[0]);
            // debugger
            // this.currentRow.payBank = res.data.rows[0].bindOpenBankName;
            if (arr && arr.length > 0 && amountList[0].paymentType === 2) {
              // this.currentRow.payBank = "光大银行";
              this.currentRow.payBank = arr[0].busiSubjectName;
              this.currentRow.paymentsName = arr[0].memName;
              this.currentRow.payCompName = arr[0].busiSubjectName;
              this.currentRow.payAccount = arr[0].subAcc;
            } else {
              this.currentRow.payBank = null;
              this.currentRow.paymentsName = null;
              this.currentRow.payCompName = null;
              this.currentRow.payAccount = null;
            }
          }
        }

        if (amountList && amountList[0].paymentType === 1) {
          params.subjectId = this.currentRow.ordersBuyerAmountList[0].sellerId;
        } else if (amountList && amountList[0].paymentType === 2) {
          params.subjectId = this.currentRow.ordersSellerAmountList[0].sellerId;
        } else if (amountList && amountList[0].paymentType === 3) {
          params.subjectId = this.currentRow.ordersSellerLv2sAmountList[0].sellerId;
        }
        switch (amountList[0].paymentType) {
          case 1:
            params.subjectType = 0;
            break;
          case 2:
            params.subjectType = 1;
            break;
          case 3:
            params.subjectType = 1;
        }

        let redRes = await apiRequest(path, action, params);
        if (redRes.status === 1) {
          if (redRes.data.rows.length < 1) {
            this.$XModal.message({
              message: "收款企业或者个人未绑定子账户，请先绑定子账户"
            });
            return;
          } else {
            let arr = redRes.data.rows.filter(item => {
              return item.busiSubjectName == this.currentRow.platformCompany;
            });
            //  console.log(arr[0]);
            // debugger
            // this.currentRow.recBank = redRes.data.rows[0].bindOpenBankName;
            if (arr && arr.length > 0 && amountList[0].paymentType === 2) {
              // this.currentRow.recBank = "光大银行";
              this.currentRow.recBank = arr[0].busiSubjectName;
              this.currentRow.recName = arr[0].memName;
              this.currentRow.recAccount = arr[0].subAcc;
              this.currentRow.recCompName = arr[0].busiSubjectName;
            } else {
              this.currentRow.recBank = null;
              this.currentRow.recName = null;
              this.currentRow.recAccount = null;
              this.currentRow.recCompName = null;
            }
          }
        }
      }
    },
    chooseFinanceAccount(account, index, field) {
      // console.log(account,index, field);
      // debugger
      this.isShowFinance = false;
      let tableData = this.$refs.xTable.getTableData().fullData;

      if (tableData[index]) {
        if (field == "paymentsName") {
          // tableData[index].payBank = "光大银行";
          tableData[index].payBank = account.busiSubjectName;
          tableData[index].paymentsName = account.memName;
          tableData[index].payAccount = account.subAcc;
          tableData[index].payCompName = account.busiSubjectName;
        } else {
          // 清空数据
          if (tableData[index].recName !== account.memName) {
            tableData[index].isDraw = 0;
            tableData[index].drawBank = null;
            tableData[index].drawAccount = null;
          }
          // tableData[index].recBank = "光大银行";
          tableData[index].recBank = account.busiSubjectName;
          tableData[index].recName = account.memName;
          tableData[index].recAccount = account.subAcc;
          tableData[index].recCompName = account.busiSubjectName;
        }
      }
    },
    openBindAccountModal(row, index) {
      if (isEmpty(row.recName)) {
        this.$XModal.message({ message: "请先选择收款人" });
        return;
      }
      this.isShowBindAccount = true;
      this.$refs.BindAccount.init(row, index);
    },
    chooseBindAccount(account, index) {
      console.log(account);
      this.isShowBindAccount = false;
      let tableData = this.$refs.xTable.getTableData().fullData;
      tableData[index].drawBank = account.bindOpenBankName;
      tableData[index].drawAccount = account.bindAccNum;
    },
    openBankAccountModal(row, index, field) {
      // console.log(row, "ddddd");
      let tableData = this.$refs.xTable.getTableData().tableData;
      if (tableData[index]) {
        // console.log(tableData[index]);
        // debugger
        let type = this.payType;
        let obj = {};
        if (row) {
          if (
            row.ordersBuyerAmountList &&
            row.ordersBuyerAmountList.length > 0
          ) {
            obj = row.ordersBuyerAmountList[0];
          } else if (
            row.ordersSellerAmountList &&
            row.ordersSellerAmountList.length > 0
          ) {
            obj = row.ordersSellerAmountList[0];
          } else if (
            row.ordersSellerLv2sAmountList &&
            row.ordersSellerLv2sAmountList.length > 0
          ) {
            obj = row.ordersSellerLv2sAmountList[0];
          }
        }
        let orderNumObj = {
          ordersNum: tableData[index].ordersNumb
        };
        obj = Object.assign(obj, orderNumObj);
        this.currentChooseColumn = field;
        if (type === 1) {
          this.isShowBankAccountModal = true;
          this.$refs.bankAccountModal.init(type, index, field, obj);
        } else {
          this.isShowFinance = true;
          this.$refs.financeAccount.init(row, index, field, this.compNameType);
        }
      } else {
        this.$XModal.message({ message: "请先选择订单" });
      }
    },
    chooseBankAccount(bankAccount, index) {
      // console.log(this.$refs.xTable.getTableData(), 'this.currentRowthis.currentRow');
      let tableData = this.$refs.xTable.getTableData().tableData;
      if (this.currentChooseColumn == "paymentsName") {
        if (bankAccount.rowType == "user") {
          tableData[index].payBank = bankAccount.openBankName;
        } else {
          tableData[index].payBank = bankAccount.bankName;
        }
        // tableData[index].payBank = bankAccount.openBankName;
        tableData[index].paymentsName = bankAccount.accountName;
        tableData[index].payAccount = bankAccount.accountNum;
        tableData[index].payCompName = bankAccount.busiSubjectName;
      } else {
        if (bankAccount.rowType == "user") {
          tableData[index].recBank = bankAccount.openBankName;
        } else {
          tableData[index].recBank = bankAccount.bankName;
        }
        // tableData[index].recBank = bankAccount.openBankName;
        tableData[index].recName = bankAccount.accountName;
        tableData[index].recAccount = bankAccount.accountNum;
        tableData[index].recCompName = bankAccount.busiSubjectName;
      }
      this.isShowBankAccountModal = false;
      this.$refs.xTable.clearValidate(this.currentChooseColumn);
    },
    closeBankAccount() {
      // console.log("closeBankAccount");
      this.isShowBankAccountModal = false;
    },
    inputPayAmountEvent(row) {
      if (isNotEmpty(row.payAmount) && row.ordersNumb == " ") {
        row.ordersNumb = null;
      }
      if (this.payType === 0) {
        if (isNaN(parseFloat(row.payAmount))) {
          row.payAmount = null;
        }
      }

      //从订单进入创建,  没有关联金额, 输入付款金额保存到关联金额
      // if (!this.canInsert && isNotEmpty(row.payAmount)) {
      //   row[this.amountListName][0].aboutAmount = row.payAmount;
      // }
      this.$refs.xTable.clearValidate("payAmount");
      this.updateFooterEvent();
    },
    async validEvent() {
      const errMap = await this.$refs.xTable.validate().catch(errMap => errMap);
      return errMap ? false : true;
    },
    uploadFile() {
      alert("上传附件");
    },
    async submitEvent() {
      this.isSubmit = true;
      this.isChangeType = true;
      // 托运人订单线下支付 请求地址
      this.createAction = "saveFlowForPaymentSeller";
      // if (this.payType === 1 && this.orderType === 1) {
      //   this.createAction = "createPaymentsSellerAndSellerLv2";
      // }
      this.$refs.xTable.updateStatus();
      let sts = await this.validEvent();
      if (!sts) {
        this.$XModal.message({ status: "error", message: "校验不通过！" });
        return;
      }
      let table = this.$refs.xTable.getTableData();
      let errMsgRow = "";
      let isErr = false;
      let isSameCompMsgRow = "";
      let isSameCompErr = false;
      table.fullData.forEach((item, index) => {
        if (item.payAccount == item.recAccount) {
          isErr = true;
          errMsgRow = `${index + 1},`;
        }
        if (item.payCompName != item.recCompName) {
          isSameCompErr = true;
          isSameCompMsgRow = `${index + 1},`;
        }
      });
      if (isErr && this.payType === 0) {
        this.$XModal.message({
          message: `序号${errMsgRow}付款人与收款人子账户不能一致`
        });
        return;
      }

      // if (table.tableData.length == 0) {
      //   this.$XModal.message({ message: "请先添收付款" });
      //   return;
      // }

      let rows;
      let outParamsObj = {};
      if (this.payType === 1) {
        rows = [];
        table.fullData.forEach(item => {
          // console.log(item);
          // debugger
          if (
            item.ordersSellerAmountList &&
            item.ordersSellerAmountList.length > 0
          ) {
            this.amountListName = "ordersSellerAmountList";
            if (
              this.isInitByOrder == "seller" ||
              this.isInitByOrder == "buyer" ||
              this.fromOrigin == "chain"
            ) {
              item.ordersSellerAmountList = item.ordersSellerAmountList.map(
                j => {
                  return Object.assign(j, {
                    aboutAmount: item.payAmount
                  });
                }
              );
            }
          } else if (
            item.ordersSellerLv2sAmountList &&
            item.ordersSellerLv2sAmountList.length > 0
          ) {
            this.amountListName = "ordersSellerLv2sAmountList";
            if (
              this.isInitByOrder == "seller" ||
              this.isInitByOrder == "buyer" ||
              this.fromOrigin == "chain"
            ) {
              item.ordersSellerLv2sAmountList = item.ordersSellerLv2sAmountList.map(
                j => {
                  return Object.assign(j, {
                    aboutAmount: item.payAmount
                  });
                }
              );
            }
          }
          // console.log(item[this.amountListName]);
          // debugger
          if (
            isEmpty(item[this.amountListName]) &&
            isNotEmpty(item.ordersNumb)
          ) {
            //导入复制的少了 关联的列表
            item[this.amountListName] = [
              {
                ordersNum: item.ordersNumb,
                ordersNumb: item.ordersNumb,
                aboutAmount: item.payAmount
              }
            ];
          }
          // console.log(item);
          // debugger
          let row = Object.assign(item, {
            ownName: item.ownName ? item.ownName : item.buyerName
          });

          // console.log(item.compName);
          // debugger
          if (
            item.ordersBuyerAmountList &&
            item.ordersBuyerAmountList.length > 0
          ) {
            row.paymentType = 1;
          } else if (
            item.ordersSellerAmountList &&
            item.ordersSellerAmountList.length > 0
          ) {
            row.paymentType = 2;
          } else if (
            item.ordersSellerLv2sAmountList &&
            item.ordersSellerLv2sAmountList.length > 0
          ) {
            row.paymentType = 3;
          } else {
            // 没有选择订单默认选2
            row.paymentType = 2;
            row.ownName = item.compName;
          }
          row.title = this.formData.title;
          row.applyTime = this.$utils.timestamp(
            this.$utils.toStringDate(this.formData.applyTime)
          );

          row.addTime = this.$utils.timestamp(
            this.$utils.toStringDate(row.addTime)
          );
          let sellerOrderPayAmount = 0;
          let secSellerOrderPayAmount = 0;
          // console.log(item.ordersSellerAmountList);
          // debugger
          if (
            item.ordersSellerAmountList &&
            item.ordersSellerAmountList.length > 0
          ) {
            sellerOrderPayAmount = item.ordersSellerAmountList.reduce(
              (prex, cur) => {
                return parseFloat(cur.aboutAmount) + prex;
              },
              0
            );
            // console.log(sellerOrderPayAmount, "sellerOrderPayAmount");
          }
          if (
            item.ordersSellerLv2sAmountList &&
            item.ordersSellerLv2sAmountList.length > 0
          ) {
            secSellerOrderPayAmount = item.ordersSellerLv2sAmountList.reduce(
              (prex, cur) => {
                return parseFloat(cur.aboutAmount) + prex;
              },
              0
            );
            // console.log(secSellerOrderPayAmount, "secSellerOrderPayAmount");
          }
          row.unusedAmount =
            item.payAmount - sellerOrderPayAmount - secSellerOrderPayAmount;
          // console.log(row.unusedAmount, item.payAmount, sellerOrderPayAmount, secSellerOrderPayAmount);
          // debugger
          row.usedAmount = sellerOrderPayAmount + secSellerOrderPayAmount;
          // if (row[this.amountListName] && row[this.amountListName].length > 0) {
          //   row[this.amountListName][0].aboutAmount = parseFloat(
          //     item.payAmount
          //   );
          // }

          rows.push(row);
        });
        outParamsObj.paymentList = rows;
        outParamsObj.payType = 0; // 1线下
      } else {
        // 线上支付  参数重传
        rows = {};
        rows.title = this.formData.title;
        rows.applyTime = this.$utils.timestamp(
          this.$utils.toStringDate(this.formData.applyTime)
        );
        // rows.ordersBuyerList = [];
        // rows.ordersSellerList = [];
        // rows.ordersSellerLv2List = [];
        rows.detailList = [];
        table.fullData.forEach(item => {
          let paramesObj = {};
          paramesObj.paymentType = 2; // 付款2 收款1
          paramesObj.clientName = item.clientName;
          paramesObj.compName = item.compName;
          paramesObj.ownName = item.compName;
          paramesObj.note = item.note;
          // paramesObj.orderId = item.ordersBuyerAmountList[0].ordersId;
          paramesObj.payAccount = item.payAccount;
          paramesObj.payAmount = item.payAmount;
          paramesObj.payBankOwn = item.payBank
          paramesObj.paymentsName = item.paymentsName;
          // paramesObj.payCompName = item.payCompName;
          paramesObj.platformCompanyId = item.platformCompanyId;
          //   item.ordersBuyerAmountList[0].platformCompanyId;
          paramesObj.recAccount = item.recAccount;
          paramesObj.recName = item.recName;
          paramesObj.recBankOwn = item.recBank;
          // paramesObj.recCompName = item.recCompName;
          paramesObj.salesMan = item.salesMan;
          // paramesObj.salesManId = item.ordersBuyerAmountList[0].salesMan;
          paramesObj.salesManId = item.salesManId;
          paramesObj.fileUuidList = item.fileUuidList;
          paramesObj.rateManage = item.rateManage;
          paramesObj.isDraw = item.isDraw;
          paramesObj.drawBank = item.drawBank;
          paramesObj.drawAccount = item.drawAccount;
          rows.detailList.push(paramesObj);
          if (
            item.ordersBuyerAmountList &&
            item.ordersBuyerAmountList.length > 0
          ) {
            paramesObj.ordersList = item.ordersBuyerAmountList;
            // paramesObj.orderId = item.ordersBuyerAmountList[0].ordersId;
          } else if (
            item.ordersSellerAmountList &&
            item.ordersSellerAmountList.length > 0
          ) {
            paramesObj.ordersList = item.ordersSellerAmountList;
            // paramesObj.orderId = item.ordersSellerAmountList[0].ordersId;
          } else if (
            item.ordersSellerLv2sAmountList &&
            item.ordersSellerLv2sAmountList.length > 0
          ) {
            paramesObj.ordersList = item.ordersSellerLv2sAmountList;
            //  paramesObj.orderId = item.ordersSellerLv2sAmountList[0].ordersId;
          }
          // console.log(paramesObj.ordersList);
          // debugger
          if (paramesObj.ordersList && paramesObj.ordersList.length > 0) {
            paramesObj.ordersList = paramesObj.ordersList.map(i => {
              // console.log(item.payAmount);
              // debugger
              return Object.assign(i, { aboutAmount: item.payAmount });
            });
          }

          // if (
          //   item.ordersBuyerAmountList &&
          //   item.ordersBuyerAmountList.length > 0
          // ) {
          //   let paramesObj = {};
          //   paramesObj.clientName = item.clientName;
          //   paramesObj.compName = item.compName;
          //   paramesObj.ownName = item.ownName; // 美琳说线上付款购方订单 ownName 取 compName
          //   paramesObj.note = item.note;
          //   paramesObj.orderId = item.ordersBuyerAmountList[0].ordersId;
          //   paramesObj.payAccount = item.payAccount;
          //   paramesObj.payAmount = item.payAmount;
          //   paramesObj.paymentsName = item.paymentsName;
          //   paramesObj.platformCompanyId =
          //     item.ordersBuyerAmountList[0].platformCompanyId;
          //   paramesObj.recAccount = item.recAccount;
          //   paramesObj.recName = item.recName;
          //   paramesObj.salesMan = item.salesMan;
          //   paramesObj.salesManId = item.ordersBuyerAmountList[0].salesMan;
          //   paramesObj.fileUuidList = item.fileUuidList;
          //   paramesObj.rateManage = item.rateManage;
          //   rows.ordersBuyerList.push(paramesObj);
          // }

          // if (
          //   item.ordersSellerAmountList &&
          //   item.ordersSellerAmountList.length > 0
          // ) {
          //   let paramesObj = {};
          //   // console.log(item, 'clientNameclientNameclientName');
          //   paramesObj.clientName = item.clientName;
          //   paramesObj.compName = item.compName;
          //   paramesObj.ownName = item.ownName;
          //   paramesObj.note = item.note;
          //   paramesObj.orderId = item.ordersSellerAmountList[0].ordersId;
          //   paramesObj.payAccount = item.payAccount;
          //   paramesObj.payAmount = item.payAmount;
          //   paramesObj.paymentsName = item.paymentsName;
          //   paramesObj.platformCompanyId =
          //     item.ordersSellerAmountList[0].platformCompanyId;
          //   paramesObj.recAccount = item.recAccount;
          //   paramesObj.recName = item.recName;
          //   paramesObj.salesMan = item.salesMan;
          //   paramesObj.salesManId = item.ordersSellerAmountList[0].salesMan;
          //   paramesObj.fileUuidList = item.fileUuidList;
          //   paramesObj.rateManage = item.rateManage;
          //   rows.ordersSellerList.push(paramesObj);
          // }

          // if (
          //   item.ordersSellerLv2sAmountList &&
          //   item.ordersSellerLv2sAmountList.length > 0
          // ) {
          //   let paramesObj = {};
          //   paramesObj.clientName = item.clientName;
          //   paramesObj.compName = item.compName;
          //   paramesObj.ownName = item.ownName;
          //   paramesObj.note = item.note;
          //   paramesObj.orderId = item.ordersSellerLv2sAmountList[0].ordersId;
          //   paramesObj.payAccount = item.payAccount;
          //   paramesObj.payAmount = item.payAmount;
          //   paramesObj.paymentsName = item.paymentsName;
          //   paramesObj.platformCompanyId =
          //     item.ordersSellerLv2sAmountList[0].platformCompanyId;
          //   paramesObj.recAccount = item.recAccount;
          //   paramesObj.recName = item.recName;
          //   paramesObj.salesMan = item.salesMan;
          //   paramesObj.salesManId = item.ordersSellerLv2sAmountList[0].salesMan;
          //   paramesObj.fileUuidList = item.fileUuidList;
          //   paramesObj.rateManage = item.rateManage;
          //   rows.ordersSellerLv2List.push(paramesObj);
          // }
        });
        outParamsObj.onlinePaymentVo = rows;
        outParamsObj.payType = 1; // 1线上
      }

      // let res = await $api.payments.request(this.createAction, rows);
      let that = this;
      setTimeout(() => {
        let uploadtable = this.$refs.fileTable.getTableData().tableData;
        outParamsObj.attachFile = uploadtable[0].fileUuidList;
        outParamsObj.applyTime = this.$utils.timestamp(
          this.$utils.toStringDate(this.formData.applyTime)
        );
        outParamsObj.instanceName = this.formData.instanceName;
        outParamsObj.instanceNum = this.formData.instanceNum;
        outParamsObj.applyUserId = this.formData.applyUserId;
        outParamsObj.leaderId = this.formData.leaderId;
        outParamsObj.managerId = this.formData.managerId;
        outParamsObj.reterenceId = this.formData.reterenceId;
        outParamsObj.flowTempletId = this.flowTempletId;
        if (this.payType === 0) {
          if (isSameCompErr) {
            this.$XModal
              .confirm(
                `序号${isSameCompMsgRow}付款人与收款人所属公司不一致,确认继续发起跨商户付款`
              )
              .then(type => {
                if (type === "confirm") {
                  showLoading();
                  $api.flowInstance.saveFlowForPaymentSeller
                    .POST({
                      data: outParamsObj
                    })
                    .then(res => {
                      hideLoading();
                      if (res.status === 1) {
                        let mesTxt =
                          this.payType === 1
                            ? "提交成功"
                            : "提交成功，待银行处理";
                        this.$XModal.message({
                          status: "success",
                          message: mesTxt
                        });
                        this.tableData = [];
                        this.$emit("close");
                      } else if (res.status == 0) {
                        showFailMsgList(res.data);
                      } else {
                        that.$XModal.alert({
                          message: res.message ? res.message : "接口异常",
                          status: "error"
                        });
                      }
                    });
                }
              });
          } else {
            showLoading();
                  $api.flowInstance.saveFlowForPaymentSeller
                    .POST({
                      data: outParamsObj
                    })
                    .then(res => {
                      hideLoading();
                      if (res.status === 1) {
                        let mesTxt =
                          this.payType === 1
                            ? "提交成功"
                            : "提交成功，待银行处理";
                        this.$XModal.message({
                          status: "success",
                          message: mesTxt
                        });
                        this.tableData = [];
                        this.$emit("close");
                      } else if (res.status == 0) {
                        showFailMsgList(res.data);
                      } else {
                        that.$XModal.alert({
                          message: res.message ? res.message : "接口异常",
                          status: "error"
                        });
                      }
                    });
          }
        } else {
          showLoading();
          $api.flowInstance.saveFlowForPaymentSeller
            .POST({
              data: outParamsObj
            })
            .then(res => {
              hideLoading();
              if (res.status === 1) {
                let mesTxt =
                  this.payType === 1 ? "提交成功" : "提交成功，待银行处理";
                this.$XModal.message({ status: "success", message: mesTxt });
                this.tableData = [];
                this.$emit("close");
              } else if (res.status == 0) {
                showFailMsgList(res.data);
              } else {
                that.$XModal.alert({
                  message: res.message ? res.message : "接口异常",
                  status: "error"
                });
              }
            });
        }

        this.$emit("init");
      }, 100);
    },
    footerCellClassName({ $rowIndex, column, columnIndex }) {
      return "footer-cell";
    },
    footerMethod({ columns, data }) {
      return paymentFooter({ columns, data, rowName: "合计" });
    },
    updateFooterEvent() {
      this.$refs.xTable.updateFooter();
    },
    async initPlatCompMap() {
      if (isEmpty(this.platformCompMap)) {
        let res = await $api.department.get("listCompany");
        let map = {};
        res.data.rows.forEach(item => {
          map[item.name] = item.id;
        });
        this.platformCompMap = map;
      }
    }
  }
};
</script>

<style>
.pay-modal-header .vxe-form .vxe-form--item {
  padding: 0;
}

.pay-modal-header .vxe-form .vxe-form--item:first-child .vxe-input--inner,
.pay-modal-header
  .vxe-form
  .vxe-form--item:first-child
  .vxe-input:not(.is--disabled).is--active
  .vxe-input--inner,
.pay-modal-header .vxe-form .vxe-form--item:first-child .vxe-form--item-title {
  border-bottom: none;
}

.pay-modal-header .vxe-form--item-title {
  height: 50px;
  line-height: 50px;
  background: #fafafa;
  border: 1px solid #f2f1f1;
}

.pay-modal-header .vxe-input,
.pay-modal-header .vxe-form--item-content,
.pay-modal-header .ivu-select {
  height: 50px;
}

.pay-modal-header .vxe-input--inner {
  border-radius: 0;
  border: 1px solid #f2f1f1;
}

.pay-modal-header .vxe-input:not(.is--disabled).is--active .vxe-input--inner {
  border: 1px solid #f2f1f1;
}

.pay-modal-header .ivu-select-single .ivu-select-selection,
.pay-modal-header .ivu-input {
  height: 50px;
  border-radius: 0px;
  border: 1px solid #f2f1f1;
  box-shadow: none;
}

.pay-modal-header
  .ivu-select-single
  .ivu-select-selection
  .ivu-select-selected-value,
.pay-modal-header
  .ivu-select-single
  .ivu-select-selection
  .ivu-select-placeholder {
  height: 50px;
  line-height: 50px;
}

.pay-modal-main {
  padding-top: 20px;
}

/*********************** */
</style>